module.exports = require("node:net");